import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
} from '@material-ui/core';
import { StyledTableCell } from '../../commons/utils/TableStyles';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
import Timezone from '../../commons/timezone/Timezone.js';

const BADGE_ESTADO = {
  activo:  { backgroundColor: '#28a745', color: '#fff' },
  cerrado: { backgroundColor: '#6c757d', color: '#fff' },
};

const BADGE_ORIGEN = {
  manual:     { backgroundColor: '#17a2b8', color: '#fff' },
  checklist:  { backgroundColor: '#007bff', color: '#fff' },
  importador: { backgroundColor: '#fd7e14', color: '#fff' },
};

const badgeStyle = (map, key) => ({
  ...(map[key] || { backgroundColor: '#6c757d', color: '#fff' }),
  padding: '3px 8px',
  borderRadius: '12px',
  fontSize: '12px',
  textTransform: 'capitalize',
});

const HistoricoRelacionesGrid = (props) => {
  const [loading, setLoading]       = useState(false);
  const [relaciones, setRelaciones] = useState([]);

  useEffect(() => {
    if (!props.movilId) return;
    setLoading(true);
    Utils.getData(`/movil-relaciones?movil_id=${props.movilId}`)
      .then(res => {
        setRelaciones(Array.isArray(res) ? res : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [props.movilId]);

  const formatFecha = (fecha) => {
    if (!fecha) return '—';
    return LocaleFormat.formatDateTime(Timezone.getDateForClient(fecha));
  };

  return (
    <div className="card">
      <div className="card-content">
        <div className="card-body">
          <TableContainer>
            <Table aria-label="historico relaciones">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.activoPrincipal" defaultMessage="Activo principal" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.activoAsociado" defaultMessage="Activo asociado" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.fechaInicio" defaultMessage="Fecha inicio" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.fechaFin" defaultMessage="Fecha fin" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.estado" defaultMessage="Estado" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.origenCreacion" defaultMessage="Origen creación" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.usuarioCreacion" defaultMessage="Usuario creación" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.origenCierre" defaultMessage="Origen cierre" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormattedMessage id="historicoRelacionesGrid.column.usuarioCierre" defaultMessage="Usuario cierre" />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={9} align="center">
                      <FormattedMessage id="Cargando" defaultMessage="Cargando" />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && relaciones.length === 0 && (
                  <TableRow>
                    <StyledTableCell colSpan={9} align="center">
                      <FormattedMessage id="historicoRelacionesGrid.sinRegistros" defaultMessage="Sin relaciones registradas" />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && relaciones.map((r, i) => (
                  <TableRow key={i}>
                    <StyledTableCell align="left">{r.activo_principal || '—'}</StyledTableCell>
                    <StyledTableCell align="left">{r.activo_asociado  || '—'}</StyledTableCell>
                    <StyledTableCell align="left">{formatFecha(r.fecha_hora_inicio)}</StyledTableCell>
                    <StyledTableCell align="left">{formatFecha(r.fecha_hora_fin)}</StyledTableCell>
                    <StyledTableCell align="left">
                      <span style={badgeStyle(BADGE_ESTADO, r.estado)}>{r.estado === 'activo' ? 'Activo' : 'Cerrado'}</span>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {r.origen_creacion
                        ? <span style={badgeStyle(BADGE_ORIGEN, r.origen_creacion)}>{r.origen_creacion}</span>
                        : '—'}
                    </StyledTableCell>
                    <StyledTableCell align="left">{r.usuario_creacion || '—'}</StyledTableCell>
                    <StyledTableCell align="left">
                      {r.origen_cierre
                        ? <span style={badgeStyle(BADGE_ORIGEN, r.origen_cierre)}>{r.origen_cierre}</span>
                        : '—'}
                    </StyledTableCell>
                    <StyledTableCell align="left">{r.usuario_cierre || '—'}</StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default HistoricoRelacionesGrid;
